<template>
	
</template>

<script>
	export default {
		name: "session-expiration-checker",
		props: ["loginRoute", "timeOut", "checkRoute"],
		data() {
			return {
				interval: null
			}
		},
		mounted() {
			const interval = (((parseFloat(this.timeOut) + 0.3) * 60) * 1000);
			const self = this;
			this.interval = setInterval(() => {
				axios.post(this.checkRoute, {})
					.then(function (response) {
						if(response.data.expired) {
							setTimeout(() => window.location.href = self.loginRoute, self.beforeRedirectTimeOut);
						}
					})
					.catch(function (response) {
						setTimeout(() => window.location.href = self.loginRoute, self.beforeRedirectTimeOut);
					});
			}, interval);
		},
		beforeDestroy () {
			clearInterval(this.interval)
		}
	}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/session-expiration-checker.vue